import { defineComponent as _defineComponent } from 'vue';
import { ref, watch } from "vue";
import { getObjectStoreDetails } from "@/api/objectStores";
import { errorMessageAsString } from "@/utils/simple-error";
import LoadingSpan from "@/components/LoadingSpan.vue";
import DescribeObjectStore from "@/components/ObjectStore/DescribeObjectStore.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'ShowSelectedObjectStore',
    props: {
        forWhat: null,
        preferredObjectStoreId: null
    },
    setup(__props) {
        const props = __props;
        const objectStore = ref(null);
        const loading = ref(true);
        const error = ref(null);
        async function fetch() {
            loading.value = true;
            try {
                objectStore.value = await getObjectStoreDetails(props.preferredObjectStoreId);
            }
            catch (e) {
                error.value = errorMessageAsString(e);
            }
            finally {
                loading.value = false;
            }
        }
        watch(() => props.preferredObjectStoreId, async () => {
            fetch();
        });
        fetch();
        const loadingMessage = "Loading storage location details";
        return { __sfc: true, props, objectStore, loading, error, fetch, loadingMessage, LoadingSpan, DescribeObjectStore };
    }
});
